import React, { useCallback } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { Container, Box, Title, FormBox, Logo, LogoBox } from './styles';
import LogoImage from '../../assets/logomarca.png'
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { getValidationErrorsMessage } from '../../utils/getValidationErrors';
import { useRoute } from '../../hooks/Route';

const Login: React.FC = () => {

  const { signIn } = useAuth();
  const { addToast } = useToast();
  const history = useHistory();
  const { setRouteActive } = useRoute();

  const { register, handleSubmit } = useForm();


  const handleLogin = useCallback(
    async (data) => {
      try {
        const schema = Yup.object().shape({
          email: Yup.string()
            .required('E-mail é obrigatório')
            .email('Digite um email válido'),
          password: Yup.string()
            .required('E-Senha é obrigatório')
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        console.log(process.env.REACT_APP_API_URL)
        await signIn({
          email: data.email,
          password: data.password,
        });
        setRouteActive('register-project')
        history.push('/register-project');


        addToast({
          type: 'success',
          title: `Login realizado com sucesso.`,
        });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrorsMessage(err);
          addToast({
            type: 'error',
            title: 'Erro no preenchimento do Login:',
            description: errors,
          });
          return;
        }
        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: err.response?.data.message,
        });

      }
    },
    [signIn, addToast, history, setRouteActive],
  );



  return (
    <Container>
      <Box>
        <LogoBox>
          <Logo src={LogoImage} />
        </LogoBox>
        <Title>Data Manager</Title>
        <FormBox>
          <Form onSubmit={handleSubmit(handleLogin)}>
            <Form.Group>
              <Form.Label className="text-muted "> Email</Form.Label>
              <Form.Control  {...register("email")} type="email" placeholder="Entre com o email" />
            </Form.Group>
            <Form.Group >
              <Form.Label className="text-muted ">Senha</Form.Label>
              <Form.Control {...register("password")} type="password" placeholder="Entre com a senha" />
            </Form.Group>
            <Button variant="success" type="submit" className="btn mb-4 ">Acessar</Button>
          </Form>
        </FormBox>
      </Box>
    </Container>

  )



}

export default Login;